// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"Tabs_tabsWrapper__29Nt5","tabs":"Tabs_tabs__38Oir","primary":"Tabs_primary__38fpp","secondary":"Tabs_secondary__1poLk","tab":"Tabs_tab__36bdL"};